import Vue from 'vue'
import axios from 'axios'
import eventHref from '../eventhref.js'
// import formurlencoded from 'form-urlencoded';
import qs from 'qs'
import $ from '../base.js'

axios.interceptors.request.use(
  async (config) => {
    let token = $.data.get('ShopMemberUserToken')

    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    if (token) {
      config.headers.Authorization = token
    } else {
      // 不登录可以看到商品信息
      // location.href = '/#/login'
    }

    // 对get请求的数组类型传参进行序列化
    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    // sratload();
    return config
  }
)

axios.interceptors.response.use(
  response => {
    // return;
    if (response.data.message && response.data.message.indexOf('请先登录') > -1) {
      $.data.remove('MemberId')
      $.data.remove('MemberInfo')
      $.data.remove('ShopMemberUserToken')
      location.href = '/#/login'
      return
    }
    return response
  },
  error => {
    console.error(error)
    return Promise.reject(error)
  }
)

Vue.directive('follow-scroll', {
  inserted: function (el, binding) {
    let leftIds = []
    let topIds = []
    if (binding.value.left) leftIds = binding.value.left
    if (binding.value.top) topIds = binding.value.top
    el.onscroll = function (ev) {
      let top = el.scrollTop
      let left = el.scrollLeft
      leftIds.forEach((id) => {
        document.querySelector(id).scrollLeft = left
      })
      topIds.forEach((id) => {
        document.querySelector(id).scrollTop = top
      })
    }
  }
})
Vue.directive('show-over', {
  inserted: function (el, binding) {
    let selector = binding.value.selector
    let css = binding.value.css
    let ids = binding.value.ids
    el.onmouseover = () => {
      let trs = el.querySelectorAll(selector)
      trs.forEach((obj, obj_index) => {
        obj.onmouseover = () => {
          obj.className += ' ' + css
          ids.forEach((id) => {
            let mobj = document.querySelector(id).querySelectorAll(selector)[obj_index]
            mobj.className += ' ' + css
          })
        }
        obj.onmouseout = () => {
          obj.className = obj.className.replace(' ' + css, '')
          ids.forEach((id) => {
            let mobj = document.querySelector(id).querySelectorAll(selector)[obj_index]
            mobj.className = mobj.className.replace(' ' + css, '')
          })
        }
      })
    }
  }
})

// 下拉刷新
Vue.directive('drop-down', {
  inserted: function (el, binding) {
    let datas = {
      s: {
        x: 0,
        y: 0
      },
      e: {
        x: 0,
        y: 0
      }
    }
    let _e = null
    el.ontouchstart = (e) => {
      datas.s.x = e.touches[0].screenX
      datas.s.y = e.touches[0].screenY
      _e = e
    }
    let isInTow = false
    el.ontouchmove = (e) => {
      datas.e.x = e.touches[0].screenX
      datas.e.y = e.touches[0].screenY
      if (el.scrollTop == 0 && datas.e.y > datas.s.y) {
        isInTow = true
        binding.value.callback(datas.e.y - datas.s.y)
      }
    }
    el.ontouchend = () => {
      if (el.scrollTop == 0) {
        let yc = datas.e.y - datas.s.y
        if (yc > 50 && datas.e.y != 0) {
          binding.value.post('up')
        } else {
          binding.value.post(0)
        }
      }
      datas = {
        s: {
          x: 0,
          y: 0
        },
        e: {
          x: 0,
          y: 0
        }
      }
    }
    el.onscroll = () => {
      if (el.scrollTop >= el.scrollHeight - el.offsetHeight - 100) {
        binding.value.post('down')
      }
    }
  }
})
// 手势扩展类
Vue.directive('gesture', {
  inserted: function (el, binding) {
    let datas = {
      s: {
        x: 0,
        y: 0,
        time: new Date()
      },
      e: {
        x: 0,
        y: 0,
        time: new Date()
      }
    }
    let _e = null
    el.ontouchstart = (e) => {
      datas.s.x = e.touches[0].screenX
      datas.s.y = e.touches[0].screenY
      datas.s.time = new Date()
      _e = e
    }
    el.ontouchmove = (e) => {
      datas.e.x = e.touches[0].screenX
      datas.e.y = e.touches[0].screenY
      datas.e.time = new Date()
    }
    el.ontouchend = () => {
      let xc = datas.e.x - datas.s.x
      if (datas.e.time.getTime() - datas.s.time.getTime() < 1) return
      if (xc > 100) {
        binding.value.callback(1, _e)
      }
      if (xc < -100) {
        binding.value.callback(2, _e)
      }
    }
  }
})

Vue.directive('scroll', {
  inserted: function (el, binding) {
    // console.log(binding)
    let arg = binding.arg
    let cleanOutSelect = function () {
      try {
        document.selection.empty()
      } catch (exp) {
        try {
          window.getSelection().removeAllRanges()
        } catch (exp) { }
      }
    }
    if (binding.value.value) {
      let length = el.children[0].offsetHeight

      if (arg == 'top') {
        el.scrollTop = binding.value.value * length
      }
      if (arg == 'left') {
        el.scrollLeft = binding.value.value * length
      }
    }
    el.ontouchstart = function (ev) {
      let length = el.children[0].offsetHeight

      let et = ev.changedTouches[0]
      let disX = et.clientX - el.offsetLeft
      let disY = et.clientY - el.offsetTop
      let thisTop = el.scrollTop
      let thisLeft = el.scrollLeft

      document.ontouchmove = function (ev) {
        let et = ev.changedTouches[0]
        let l = et.clientX - disX
        let t = et.clientY - disY

        if (arg == 'top') {
          el.scrollTop = thisTop - t
        }
        if (arg == 'left') {
          el.scrollLeft = thisLeft - l
        }
      }
      document.ontouchend = function () {
        if (arg == 'top') {
          let mo = el.scrollTop % length
          let top = 0
          if (mo > length / 2) top = el.scrollTop - el.scrollTop % length + length
          else top = el.scrollTop - el.scrollTop % length
          el.scrollTop = top
          console.log(top)
          // console.log(mo,el.scrollTop , length)
          binding.value.callback(top / length, binding.value)
        }
        if (arg == 'left') {
          let mo = el.scrollLeft % length
          if (mo > length / 2) el.scrollLeft = el.scrollLeft - el.scrollLeft % length + length
          else el.scrollLeft = el.scrollLeft - el.scrollLeft % length
          binding.value.callback(el.scrollLeft / length)
        }
        document.ontouchmove = null
        document.ontouchend = null
      }
    }
  }

})
// v-dialogDrag: 弹窗拖拽属性
Vue.directive('dialogDrag', {
  bind (el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el_dialogHeader') || el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el_dialogBox') || el.querySelector('.el-dialog')

    dialogHeaderEl.style.cssText += ';cursor:move;'
    // dragDom.style.cssText += ';top:0px;'

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = (() => {
      if (window.document.currentStyle) {
        return (dom, attr) => dom.currentStyle[attr]
      } else {
        return (dom, attr) => getComputedStyle(dom, false)[attr]
      }
    })()

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      const screenWidth = document.body.clientWidth // body当前宽度
      const screenHeight = document.documentElement.clientHeight // 可见区域高度(应为body高度，可某些环境下无法获取)

      const dragDomWidth = dragDom.offsetWidth // 对话框宽度
      const dragDomheight = dragDom.offsetHeight // 对话框高度

      const minDragDomLeft = dragDom.offsetLeft
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth

      const minDragDomTop = dragDom.offsetTop
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight

      // 获取到的值带px 正则匹配替换
      let styL = sty(dragDom, 'left')
      let styT = sty(dragDom, 'top')

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (styL.includes('%')) {
        styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100)
      } else {
        styL = +styL.replace(/\px/g, '')
        styT = +styT.replace(/\px/g, '')
      };

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        let left = e.clientX - disX
        let top = e.clientY - disY

        // 边界处理
        if (-(left) > minDragDomLeft) {
          left = -(minDragDomLeft)
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft
        }

        if (-(top) > minDragDomTop) {
          top = -(minDragDomTop)
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop
        }

        // 移动当前元素
        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
      }

      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})
// 数据缓存
let storage = {
  get (key) {
    return $.toJs(localStorage.getItem(key))
  },
  set (key, data) {
    localStorage.setItem(key, JSON.stringify(data))
  },
  remove (key) {
    localStorage.removeItem(key)
  }
}

var base = {
  // 判断登录
  isLogin: function (callback) {
    if (!this.user) {
      this.$store.state.isSowLogin = 1
      this.$store.state.funLogin = callback
      return false
    }
    return true
  },
  // 鼠标滑过标签
  hoverTag: function (key) {
    if (window['clear_' + key]) clearTimeout(window['clear_' + key])
    this[key] = 1
  },
  // 鼠标滑出标签
  outTag: function (key, callback) {
    window['clear_' + key] = setTimeout(() => {
      this[key] = 0
      callback && callback()
    }, 100)
  },
  // 收藏
  favorite: function (sURL, sTitle) {
    sURL = sURL || window.location
    sTitle = sTitle || document.title
    try {
      window.external.addFavorite(sURL, sTitle)
    } catch (e) {
      try {
        window.sidebar.addPanel(sTitle, sURL, '')
      } catch (e) {
        $.ui.toast('您的浏览器不支持此操作，请使用Ctrl+D进行添加')
      }
    }
  },
  download (url, data, callback) {
    axios.post(url, data, {
      responseType: 'blob'
    }).then(response => {
      callback(response.data)
    })
  },
  /**
   * @description: 下载文件，请求方式get，获取后端返回的二进制文件流
   * @param {string} url 请求url
   * @param {Object} data 请求的params传参
   * @param {Function} callback 回调函数
   * @return {Blob}
   * @author: lsqi
   */
  downloadG (url, data, callback) {
    let token = $.data.get('ShopMemberUserToken')
    let header = null
    if (token) {
      header = {
        Token: token
      }
    }
    axios.get(url, {
      params: data,
      responseType: 'blob',
      headers: header
    })
      .then(response => {
        callback(base.returnData(response.data))
      })
  },
  /**
   * @description: 下载excel文件
   * @param {string} fileName 定义下载文件的文件名
   * @param {Object} data 后端请求返回的二进制文件流
   * @return {null}
   * @author: lsqi
   */
  downloadExcel (fileName, data) {
    if ('msSaveOrOpenBlob' in navigator) {
      let blob = new Blob([data])
      window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
      let blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      let fileUrl = URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.setAttribute('href', fileUrl)
      a.setAttribute('download', fileName)
      a.click()
    }
  },
  /**
   * @description: 单个文件上传
   * @param {string} url 请求url
   * @param {File} file 上传的文件对象
   * @param {Function} callback 回调
   * @return {*}
   * @author: lsqi
   */
  upload (url, file, callback) {
    const formData = new FormData()
    formData.append('file', file)
    let token = $.data.get('ShopMemberUserToken')
    let header = {
      'Content-Type': 'multipart/form-data'
    }
    if (token) {
      header.Token = token
    }
    window['isPostData'] = 1
    axios.post(url, formData, {
      headers: header,
      withCredentials: true
    })
      .then(response => {
        window['isPostData'] = 0
        callback(base.returnData(response.data))
      })
      .catch(error => { console.log(JSON.stringify(error)) })
  },
  // 执行post请求
  post: (url, data, callback, manyKey, hkey, htime, type) => {
    if (hkey) {
      let d = storage.get(hkey)
      if (d) {
        if (htime && d.time) {
          let diffTime = $.date.diff(new Date(d.time), 'm', new Date())

          if (diffTime <= 30) {
            callback(base.returnData(d.data, type))
            return
          }
        } else {
          callback(base.returnData(d.data, type))
          return
        }
      }
    }
    let token = ''
    if (data.token) {
      token = data.token
    } else {
      token = $.data.get('ShopMemberUserToken')
    }

    let header = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    if (token) {
      header.Token = token
    }
    // if(window['isPostData'])return;
    window['isPostData'] = 1
    // console.log('ssss:'+JSON.stringify(data))
    axios.post(url, qs.stringify(data), {
      headers: header,
      withCredentials: true
    })
      .then(response => {
        window['isPostData'] = 0
        callback(base.returnData(response.data, type))
        if (hkey) {
          if (response.data.code == '0000') {
            storage.set(hkey, {
              data: response.data,
              time: new Date()
            })
          }
        }
      }).catch(error => { console.log(JSON.stringify(error)) })
  },
  post2: function (url, data, callback) {
    var ths = this
    var token = $.data.get('ShopMemberUserToken')
    var header = {
      Token: token
    }
    axios.post(url, data, {
      headers: header
    })
      .then(response => {
        callback && callback(response.data)
      })
  },
  postJson: function (url, data, callback, manyKey, hkey, htime, type) {
    if (hkey) {
      let d = storage.get(hkey)
      if (d) {
        if (htime && d.time) {
          let diffTime = $.date.diff(new Date(d.time), 'm', new Date())

          if (diffTime <= 30) {
            callback(base.returnData(d.data, type))
            return
          }
        } else {
          callback(base.returnData(d.data, type))
          return
        }
      }
    }
    let token = $.data.get('ShopMemberUserToken')
    let header = {
      'Content-Type': 'application/json;charset=utf-8'
    }
    if (token) {
      header.Token = token
    }
    // if(window['isPostData'])return;
    window['isPostData'] = 1
    // console.log('ssss:'+JSON.stringify(data))
    axios.post(url, data, {
      headers: header,
      withCredentials: true
    })
      .then(response => {
        window['isPostData'] = 0
        callback(base.returnData(response.data, type))
        if (hkey) {
          if (response.data.code == '0000') {
            storage.set(hkey, {
              data: response.data,
              time: new Date()
            })
          }
        }
      }).catch(error => { console.log(JSON.stringify(error)) })
  },
  postAll (funs) {
    axios.all(funs).then(responseList => {
      callback && callback(responseList.map((response) => {
        return response.data
      }))
    })
  },
  postFile (url, file, callback) {
    let token = $.data.get('token')

    const formData = new FormData()
    formData.append('file', file)
    if (token) {
      formData.append('token', token)
    }
    axios.post(url, formData, {
      transformRequest: [
        (data, headers) => {
          headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
          return data
        }
      ]
    })
      .then(response => {
        callback && callback(response.data)
      })
  },
  returnData: (data, type) => {
    if (type != null) {
      let d = {}
      data[type['field']].forEach((item) => {
        d[item[type['key']]] = item
      })
      return d
    } else {
      return data
    }
  },
  // 执行get请求
  get: (url, data, callback, hkey, htime, type) => {
    if (hkey) {
      let d = storage.get(hkey)
      if (d) {
        if (htime && d.time) {
          let diffTime = $.date.diff(new Date(d.time), 'm', new Date())
          if (diffTime <= 30) {
            callback(base.returnData(d.data, type))
            return
          }
        } else {
          callback(base.returnData(d.data, type))
          return
        }
      }
    }
    let token = $.data.get('ShopMemberUserToken')
    let header = null
    if (token) {
      header = {
        Token: token
      }
    }
    axios.get(url, {
      params: data,
      headers: header
    })
      .then(response => {
        callback(base.returnData(response.data, type))
        if (hkey) {
          if (response.data.code == '0000') {
            storage.set(hkey, {
              data: response.data,
              time: new Date()
            })
          }
        }
      })
  },
  get2: (url, data, callback) => {
    axios.get(url, {
      params: data
    })
      .then(response => {
        callback(response)
      })
  },
  // 执行post请求
  put: (url, data, callback, manyKey, hkey, htime, type) => {
    if (hkey) {
      let d = storage.get(hkey)
      if (d) {
        if (htime && d.time) {
          let diffTime = $.date.diff(new Date(d.time), 'm', new Date())

          if (diffTime <= 30) {
            callback(base.returnData(d.data, type))
            return
          }
        } else {
          callback(base.returnData(d.data, type))
          return
        }
      }
    }
    let token = $.data.get('ShopMemberUserToken')
    let header = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    if (token) {
      header.Token = token
    }
    // if(window['isPostData'])return;
    window['isPostData'] = 1
    axios.put(url, data, {
      headers: header
    })
      .then(response => {
        window['isPostData'] = 0
        callback(base.returnData(response.data, type))
        if (hkey) {
          if (response.data.code == '0000') {
            storage.set(hkey, {
              data: response.data,
              time: new Date()
            })
          }
        }
      }).catch(error => { console.log(JSON.stringify(error)) })
  },
  // 获取标签数据
  getData: function (e) {
    return e.currentTarget.dataset
  },
  // 跳转页
  href: function (e, data, callback) {
    let path = ''
    let _data = {}
    if (e.constructor == String) {
      path = e
      _data = data || {}
    } else {
      let data = this.getData(e)
      path = data.path
      for (let key in data) {
        if (key != 'path') _data[key] = data[key]
      }
    }
    // 在当前页面打开---需要拼接path
    let attr = $._param(_data)
    if (attr != '') {
      path += (path.indexOf('?') > -1 ? '&' : '?') + attr
    }
    if (callback) {
      eventHref.$on('pageCallBack', (data) => {
        callback(data)
        eventHref.$off('pageCallBack')
      })
    }
    this.$router.push({
      path: path
    })

    // 打开新页签的方法----
    // const link = this.$router.resolve({
    //   path: path,
    //   query: _data
    // })
    // window.open(link.href, '_blank')
  },
  // 返回上一页
  back: function (data) {
    if (data) {
      eventHref.$emit('pageCallBack', data)
    }
    this.$router.go(-1)
  },
  // 扩展
  extend: (data1, data2) => {
    for (let _key in data2) {
      data1.prototype[_key] = data2[_key]
    }
  }
}
export default base



// WEBPACK FOOTER //
// ./src/helpers/vue/base.js